import automaticValidationSchema from "../../../Utilities/ValidationSchemaSetup/automaticValidationSchema";
import React, { useEffect, useState } from "react";
import createInitialValue from "../../../Utilities/InitialValuesSetup/createInitialValue";

import axios from "axios";

/* import Swal from "sweetalert2";
import _ from "lodash"; */
import {  Form, Formik } from "formik";
import CreateQuoteObject from "../CreateQuoteObject";

import * as Yup from "yup";
import { useNavigate, useParams } from "react-router";

import CreateQuoteArray from "../CreateQuoteArray";


//import SaveChanges from "../../../Components/Modals/SortHealthInsureProduct";

//import transData from "../../../Utilities/LifeInsuranceRequestBodies/ReInitializeValues/reinitializeUpdated";
import ShriRamreqbodyGen from "../../../Utilities/LifeInsuranceRequestBodies/CreateQuoteRequestBodies/ShriRamReqBodyGen";
import swal from "sweetalert2";


//import submitProautofill from "../../../Utilities/AutoFillsetup/submitProautofill";
import CQ_AutoFillForm from "../../../Utilities/LifeInsuranceRequestBodies/AuotoFillSubProp/SubmitProposerAutoFillForm";
import CategoryHeader from "../../../Components/Headers/CategoryHeader";
import { CircularProgress } from "@mui/material";
//import '../../../Assets/css/LifeInsurance/CreateQuoteForm.css'


function Validateproposal(props) {
  //const [productName, setProductName] = useState("");
  //const [productUrl, setProductUrl] = useState("");
  //const [requestBody, setrequestBody] = useState({});
  //const [newRequestBody, setNewRequestBody] = useState({});
  const [productDetails, setProductDetails] = useState([]);
  //const [responseData, setResponseData] = useState({});
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});
  const [transferData, setTransferData] = useState({});
  //const [depInd, setdepInd] = useState(1);
  //const [progress, setProgress] = React.useState(0);
  //const [loggedinUserid, setLoggeinUserid] = useState({});
  const [nomineeShare, setNomineeShare] = useState(0);
  const [savedValidate, setSavedValidate] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { id } = useParams();

  const productIdArray = id.split("*");
  const productRef = productIdArray[0];
  const transId = productIdArray[1];
  const validateFormid = productIdArray[2];

  let navigate = useNavigate();

  

  let initialValues;
 
  if (
    Object.keys(productDetails).length > 0 &&
    Object.keys(savedValidate).length > 0
  ) {
    initialValues = createInitialValue(productDetails);
    
    initialValues = CQ_AutoFillForm(initialValues, savedValidate, transferData);

   
  }

  var Fields = [];
  if (Object.keys(productDetails).length > 0) {
    productDetails.requestBody.formFields.fields.map((field, index) => {
      Fields.push(field);
      return null
    });
  }

  if (Object.keys(productDetails).length > 0) {
    var SchemaArray = [];
    productDetails.requestBody.formFields.fields.map((field, index) => {
      let seperatearray = [];

      seperatearray.push(field);

      SchemaArray.push(seperatearray);
      return null
    });
  }

  var validationSchema = Yup.object().shape({});
  if (Object.keys(productDetails).length > 0) {
    validationSchema = automaticValidationSchema(SchemaArray[activeStep]);
  }
  

  const getProductConfig = () => {
    let domainExpress = "";
    //let domainDjango = "";

    if (window.location.hostname === "localhost") {
      domainExpress = process.env.REACT_APP_LOCAL_EXPRESS;
      //domainDjango = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "acuvisor.com") {
      domainExpress = process.env.REACT_APP_PRODUCTION_EXPRESS;
      //domainDjango = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domainExpress = process.env.REACT_APP_UAT_EXPRESS;
      //domainDjango = process.env.REACT_APP_UAT_DJANGO;
    }

    axios
      .get(
        `${domainExpress}/api/v1/lifeInsurance/validate-form/${productRef}`
       
      )
      .then((response) => {
        if (response.status === 200) {
          console.log("response from node", response);
          setProductDetails(response.data);
        }
      });
  };

  const getValidateFormDetails = () => {
    let domain = "";
    if (window.location.hostname === "localhost") {
      domain = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domain = process.env.REACT_APP_UAT_DJANGO;
    }

    axios
      .get(
        `${domain}/api/life-insurance/get-validate-proposal/${validateFormid}/`
      )
      .then((response) => {
        
        console.log(response, "Savedvalidate resp");
        setSavedValidate(response.data);
       
      });
  };

  const getTransferData = () => {
    let domain = "";
    if (window.location.hostname === "localhost") {
      domain = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domain = process.env.REACT_APP_UAT_DJANGO;
    }

    axios
      .get(`${domain}/api/shriram/plp-validate-response/${transId}/`)
      .then((response) => {
        setTransferData(response.data);
        console.log("trans of SP", response);
      });
  };

  useEffect(() => {
    //let productDetailsArray = [];

   
    getProductConfig();
    getValidateFormDetails();
    getTransferData();
  }, []);

 /*  const verifyValidate = (ShriRamValues) => {
    console.log("within verifyvalidate");
    axios
      .post(
        `http://65.0.70.70:8000/api/life-insurance/validate-proposal/`,

        finalreq
      )
      .then((response) => {
        console.log(response, "response in validate submit  form");
       
        if (response.data.ResultSet.ResponseCode !== "200") {
          alert(response.data.ResultSet.ResponseMsg);
        } else {
          // navigate(`/life-insurance/getbi/${transferData.bi_config_id}*${transId}*${response.data.validateProposalId}`)
        }
      });
  }; */

  const onSubmit = (values, actions) => {
    if (isLastStep()) {
      setIsSubmitting(true);
      const ShriRamValues = ShriRamreqbodyGen(values);
      console.log(ShriRamValues, "FinalRequest");
      
      console.log("req body sp", JSON.stringify(ShriRamValues));

      let domain = "";
      if (window.location.hostname === "localhost") {
        domain = process.env.REACT_APP_LOCAL_DJANGO;
      } else if (window.location.hostname.trim() === "acuvisor.com") {
        domain = process.env.REACT_APP_PRODUCTION_DJANGO;
      } else {
        domain = process.env.REACT_APP_UAT_DJANGO;
      }

      axios
        .post(
          `${domain}/api/life-insurance/submit-proposal/${transferData.A_id}/${transferData.Acuvisor_product_id}/`,
          ShriRamValues
        )
        .then((res) => {
          console.log("respons from Submit Proposer", res);
          if (res.data.ResultSet.ResponseCode === "200") {
            setIsSubmitting(false);
            navigate(`/life-insurance/proposerStatus/${transId}`);
          }else{
            swal.fire()
            setIsSubmitting(false);

          }
        })
        .catch((e) => {
          console.log("err", e);
          console.log("err des", e.response.data);
          setIsSubmitting(false);
        });
    } else {
      

      let flag = false;

      console.log("flag", flag);
      
      if (true) {
        setActiveStep(activeStep + 1);
        window.scrollTo(0, 0);

        actions.setTouched({});
        actions.setSubmitting(false);
      }
    }
  };

  const handleBack = () => {
    if (activeStep !== 0) {
      window.scrollTo(0, 0);
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    } else {
      navigate(-1);
    }
    
  };
  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  /* const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  }; */
  
  const steps = [
    "PRIMARY DETAILS",
    "PED QUESTIONS",
    "PROPOSER DETAILS",
    "NOMINEE DETAILS",
  ];

  return (
    <>
      <div className="mb-3">
        <CategoryHeader title="Life Insurance" />
      </div>
      <div id="">
        <>
          <div>
            <div className="mx-auto stepper-container">
              <div className="Stepper_container">
                <div className="steppers">
                  {steps.map((field, index) => {
                    return (
                      <div
                        className={
                          activeStep === index
                            ? "life_active"
                            : `life_step${index}`
                        }
                        onClick={() => {
                          if (index < activeStep) setActiveStep(index);
                        }}
                      >
                        <p
                          className={
                            activeStep === index ? "active_text" : "text"
                          }
                        >
                          {field}
                        </p>
                      </div>
                    );
                  })}
                </div>
                <div className="lineCon">
                  <p className="stepper"></p>
                </div>
                
              </div>
              
            </div>

            <div className="paper_con">
              <div className="paper">
                {initialValues ? (
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    enableReinitialize={true}
                    onSubmit={onSubmit}
                  >
                    {(formik) => {
                      console.log("formik val", formik);

                      return (
                        <Form autoComplete="off">
                          <div className="bg-white shadow-md rounded-card  pt-sm-4 pb-sm-5 px-sm-5 form-container">
                            {Fields[activeStep].htmlElement === "Array" ? (
                              <CreateQuoteArray
                                Field={Fields[activeStep]}
                                name={Fields[activeStep].name}
                                nomineeShare={nomineeShare}
                                setNomineeShare={setNomineeShare}
                              />
                            ) : (
                              <CreateQuoteObject
                                Field={Fields[activeStep]}
                                name={Fields[activeStep].name}
                                nomineeShare={nomineeShare}
                                setNomineeShare={setNomineeShare}
                              />
                            )}
                          </div>

                          <div
                            
                            className="btn-sec position-fixed bottom-0 mt-3"
                          >
                            {isSubmitting ? (
                              <div className="mx-auto">
                                <CircularProgress
                                  size={48}
                                  sx={{
                                    color: "red",
                                  }}
                                />
                              </div>
                            ) : (
                              <>
                                {activeStep !== 0 && (
                                  <button
                                    className="Goback_btn"
                                    type="button"
                                    onClick={handleBack}
                                  >
                                    Back
                                  </button>
                                )}
                                <button className="submitBtn" type="submit">
                                  {isLastStep() ? "Submit" : "Next"}
                                </button>
                              </>
                            )}
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                ) : (
                  <div>Loading....</div>
                )}
              </div>
            </div>
          </div>
        </>
      </div>
    </>
  );
}

export default Validateproposal;
